import { useAppLayoutStore } from "PFApp/stores/app_layout_store";
import { HTMLAttributes, PropsWithChildren, RefObject } from "react";

import css from "./scrollable_page_wrapper.module.scss";

type ScrollablePageWrapperProps = PropsWithChildren<{
  ref?: RefObject<HTMLDivElement | null>;
}> &
  Omit<HTMLAttributes<HTMLDivElement>, "style" | "className">;

export const ScrollablePageWrapper = ({ children, ref, ...rest }: ScrollablePageWrapperProps) => {
  const mainLeft = useAppLayoutStore((state) => state.mainLeft);
  const mainRight = useAppLayoutStore((state) => state.mainRight);

  return (
    <div
      ref={ref}
      className={css.scrollableContainer}
      style={{
        marginLeft: -1 * mainLeft,
        paddingLeft: mainLeft,
        paddingRight: mainRight
      }}
      {...rest}
    >
      {children}
    </div>
  );
};
